import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Separator } from '../../components/ui/separator';
const ShadcnDivider = ({ formrValue }) => {
    return (_jsxs("div", { className: "py-2", children: [formrValue.label && (_jsx("p", { className: "text-sm font-medium text-muted-foreground mb-1", children: formrValue.label })), _jsx(Separator, {})] }));
};
export { ShadcnDivider };
//# sourceMappingURL=ShadcnDivider.js.map